import React from 'react';
import { useTranslation } from 'react-i18next';

const Notification = ({ messages, onClose }) => {
  const { t } = useTranslation();
  if (!messages || messages.length === 0) return null;

  return (
    <div className="notification">
      <div className="flex justify-between items-start mb-3">
        <h3>{t('messageDownload.notificationsTitle')}</h3>
        <button 
          onClick={onClose} 
          className="notification-close"
        >
          ✕
        </button>
      </div>
      <div className="notification-messages">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`notification-item ${msg.success ? 'success' : 'error'}`}
          >
            <div className="notification-item-title">{msg.functioneelId}</div>
            <div className="notification-item-message">{msg.status}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notification;